<template>
  <v-app>
    <base-app-bar v-model="drawer" />
    <v-main class="main-content bg-body">
      <navigation-drawer v-model="drawer" />
      <base-view />
    </v-main>
    <footer-view />
    <!-- <mobile-navigation /> -->
    <renew-token />
  </v-app>
</template>

<script>
import RenewToken from "../../components/global/RenewToken.vue";

export default {
  name: "BaseLayout",
  data: () => ({
    drawer: false,
  }),
  components: {
    BaseAppBar: () => import("./AppBar.vue"),
    BaseView: () => import("./View.vue"),
    FooterView: () => import("./Footer.vue"),
    // MobileNavigation: () => import("./MobileNavigationBar.vue"),
    NavigationDrawer: () => import("./NavigationDrawer.vue"),
    RenewToken,
  },
};
</script>
